// EDEN · home-page quotes & verses (Module-D spec §6: a signature, art-like surface — calm,
// generous, beautiful. It encourages; it never measures).
//
// Static, curated, day-rotating. The owner curates this list. English-only — EDEN's UI is
// English; Khmer is retained only as a display font for imported student names.
// No metrics, no scores, no streaks ride along with this file — ever.

export interface Quote {
  en: string;
  ref: string; // attribution — scripture reference or author
}

export const QUOTES: Quote[] = [
  { en: "Let the favor of the Lord our God be upon us, and establish the work of our hands.", ref: "Psalm 90:17" },
  { en: "Train up a child in the way he should go; even when he is old he will not depart from it.", ref: "Proverbs 22:6" },
  { en: "Whatever you do, work heartily, as for the Lord and not for men.", ref: "Colossians 3:23" },
  { en: "A teacher affects eternity; no one can tell where their influence stops.", ref: "Henry Adams" },
  { en: "Let us not grow weary of doing good, for in due season we will reap, if we do not give up.", ref: "Galatians 6:9" },
  { en: "The best teachers are those who show you where to look, but don't tell you what to see.", ref: "Alexandra K. Trenfor" },
  { en: "Your word is a lamp to my feet and a light to my path.", ref: "Psalm 119:105" },
  { en: "Education is not the filling of a pail, but the lighting of a fire.", ref: "W. B. Yeats" },
  { en: "And whatever you do, in word or deed, do everything in the name of the Lord Jesus.", ref: "Colossians 3:17" },
  { en: "Teaching is the one profession that creates all other professions.", ref: "Unknown" },
  { en: "Commit your work to the Lord, and your plans will be established.", ref: "Proverbs 16:3" },
  { en: "Patience and time do more than strength or passion.", ref: "Jean de La Fontaine" },
];

/** The day's quote: stable for the whole day, different tomorrow (no state, no tracking). */
export function quoteOfTheDay(now = new Date()): Quote {
  const start = Date.UTC(now.getFullYear(), 0, 0);
  const dayOfYear = Math.floor((Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()) - start) / 86_400_000);
  return QUOTES[dayOfYear % QUOTES.length]!;
}
